import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Container, Service } from '../../../../symphony';
import { ITrackAction } from '../../global-interface';
import { lePlaygroundContext } from '../../global-constants';

declare const slTrack: (payload: {
    action: string;
    element: string;
    entityId?: number;
    redirectUrl?: string;
    userId?: string;
}) => void;

@Service()
export class SlTrackingService {
	constructor() {
		const unsubscriber: Subject<void> = Container.take(
			lePlaygroundContext.value,
			'unsubscriber',
		);
		this.trackAction$
			.pipe(
				filter((a) => !!a),
				takeUntil(unsubscriber),

				tap((action: ITrackAction) => {
					slTrack({
						action: action.action,
						element: action.element,
						entityId: action.entityId || null,
						redirectUrl: action.redirectUrl || null,
						userId: action.userId || null,
					});
				}),
			)
			.subscribe();
	}

	public trackAction$ = new BehaviorSubject<ITrackAction>(null);
}
